export default [{
  title: 'Dashboards',
  id: 'dashboards-main-menu',
  sub: [{
    path: { name: 'trace' },
    title: 'Trace',
    visibleFor: ['ROLE_TRACER']
  }, {
    path: { name: 'locationPortal' },
    title: 'Location Portal',
    visibleFor: ['ROLE_LOCATION_MANAGER']
  }, {
    path: { name: 'supplychainoverview' },
    title: 'Supply Chain Overview',
    visibleFor: ['ROLE_TRACER']
  }, {
    path: { name: 'treeRevisionList' },
    title: 'Revision History',
    visibleFor: ['ROLE_TREE_UPLOADER']
  }]
}, {
  title: 'Registration',
  id: 'registration-main-menu',
  sub: [{
    path: { name: 'repackage' },
    title: 'Repackage',
    visibleFor: ['ROLE_TREE_EDITOR']
  }, {
    path: { name: 'registerTrackingevent' },
    title: 'Register Tracking',
    visibleFor: ['ROLE_TRACKER']
  }, {
    path: { name: 'pos' },
    title: 'Point of Sale',
    visibleFor: ['ROLE_TRACKER']
  }, {
    path: { name: 'enablecoderange' },
    title: 'Enable Code Range',
    visibleFor: ['ROLE_NODE_EDITOR']
  }]
}, {
  title: 'Shipments',
  id: 'shipments-main-menu',
  sub: [{
    path: '/compass/pickinglists',
    title: 'Shipments',
    visibleFor: ['ROLE_PICKING_LIST_MANAGER', 'ROLE_PICKER']
  }]
}, {
  title: 'Configuration',
  id: 'tt-configuration-main-menu',
  sub: [{
    path: { name: 'recalls' },
    title: 'Recalls',
    visibleFor: ['ROLE_RECALL_MANAGER']
  }, {
    path: { name: 'packageTypes' },
    title: 'Package types',
    visibleFor: ['ROLE_PACKAGE_TYPE_MANAGER']
  }, {
    path: { name: 'businessLocations' },
    title: 'Business Locations',
    visibleFor: ['ROLE_LOCATION_MANAGER']
  }]
}]



// WEBPACK FOOTER //
// ./src/data/menu-items/track-trace.js